import { buildGlobalAction, buildInlineComputedView } from "./../../builder.js";
class ClickhouseContactsNamespace {
  constructor(clientOrParent) {
    this.clientOrParent = clientOrParent;
    /** Executes the getContacts global action. */
    this.getContacts = buildGlobalAction(this, {
      type: "globalAction",
      functionName: "getContacts",
      operationName: "getContacts",
      operationReturnType: "ClickhouseContactsGetContacts",
      namespace: ["clickhouse", "contacts"],
      variables: {}
    });
    /** Executes the insertContacts global action. */
    this.insertContacts = buildGlobalAction(this, {
      type: "globalAction",
      functionName: "insertContacts",
      operationName: "insertContacts",
      operationReturnType: "ClickhouseContactsInsertContacts",
      namespace: ["clickhouse", "contacts"],
      variables: {
        contacts: { required: false, type: "String" },
        source: { required: false, type: "String" },
        retry: { required: false, type: "Boolean" }
      }
    });
    /** Executes an inline computed view. */
    this.view = buildInlineComputedView(this, {
      type: "computedView",
      operationName: "gellyView",
      functionName: "view",
      gqlFieldName: "gellyView",
      namespace: ["clickhouse", "contacts"],
      variables: {
        query: { type: "String", required: true },
        args: { type: "JSONObject" }
      }
    });
    this.connection = this.clientOrParent.connection;
  }
}
export {
  ClickhouseContactsNamespace
};
//# sourceMappingURL=contacts.js.map
